


export default [
    
    {
        path: '/',
        name: 'login',
        component: () => import('./Login')
    },       
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('./Dashboard/Dashboard')
    }, 
    {
        path: '/parceiros',
        name: 'parceiros',
        component: () => import('./Parceiros/Parceiros')
    }, 
    {
        path: '/servicos',
        name: 'servicos',
        component: () => import('./Servicos/Servicos')
    }, 
    {
        path: '/motoristas',
        name: 'motoristas',
        component: () => import('./Motoristas/Motoristas')
    }, 
    {
        path: '/indicacoes',
        name: 'indicacoes',
        component: () => import('./Indicacoes/Indicacoes')
    }, 
    {
        path: '/promocoes',
        name: 'promocoes',
        component: () => import('./Promocoes/Promocoes')
    }, 
]